import {TrackingStreamSectionContext} from '../../../types';
import {TrackingClientState, TrackingClientStateHolder} from './clientState';
import {getSourceHistory} from './sourceHistory';

export const getSourceSortChannel = (
  state: TrackingClientState
): string | undefined => {
  const currentPage = getSourceHistory({index: 0, state});
  if (currentPage?.sortChannel) {
    return currentPage.sortChannel;
  }

  const prevPage = getSourceHistory({index: 1, state});
  return prevPage?.sortChannel;
};

export const trackSortChannel =
  (stateHolder: TrackingClientStateHolder) =>
  ({section}: {section: TrackingStreamSectionContext}) => {
    const currentState = stateHolder.getCurrent();
    const currentPage = getSourceHistory({index: 0, state: currentState});
    if (currentPage) {
      currentPage.sortChannel = section.sortChannel;
    }
  };
